/**
 *
 * Asynchronously loads the component for FacebookShareButton
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/components/facebook-share-button/loadable.js